import request from '@/utils/request'

let RlareApi = {

  /*报损报溢列表*/
  list(data) {
    return request._post('/shop/plus.rlare.Index/index', data);
},
/*添加报损报溢*/
add(data) {
    return request._post('/shop/plus.rlare.Index/add', data);
},
/*修改报损报溢*/
edit(data) {
    return request._post('/shop/plus.rlare.Index/edit', data);
},
/*删除报损报溢*/
del(data) {
    return request._post('/shop/plus.rlare.Index/del', data);
},
/*报损报溢详情*/
detail(data) {
  return request._post('/shop/plus.rlare.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.rlare.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.rlare.Setting/getSetting', data, errorback);
    },
}
export default RlareApi;



// WEBPACK FOOTER //
// ./src/api/rlare.js